<div class="col-lg-12 padding-20">
    <div class="row m-0">
        <div class="col-lg-12 header block" >
            <h5 *ngIf="!readOnly" class="card-title text-secondary bold-font padding-top-5 header-title">Send Message</h5>
            <h5 *ngIf="readOnly" class="card-title text-secondary bold-font padding-top-5 header-title">Sent Message</h5>
        </div>
        <div class="col-lg-12 card-body border-right border regular-font">
            <div class="message-box">
                <p *ngIf="!readOnly" class="card-text semi-bold-font padding-top-5 message">Please enter a message and select the file(s) you would like to send to your Lawyer</p>
                <div>
                    <mat-form-field class="padding-left-10 width-100" >
                        <mat-label *ngIf="!readOnly" class="font-18">Message to your lawyer</mat-label>
                        <textarea matInput class ="dialog-text-area"
                                  rows="5"
                                  [readonly]="readOnly"
                                  [(ngModel)] = "messageText"
                        >
                        </textarea>
                    </mat-form-field>
                </div>

            </div>
            <div *ngIf="!readOnly" class="padding-left-20 padding-right-20">
                <button mat-raised-button color="white" (click)="multiFileUploadInput.click()">
                    <mat-icon>attachment</mat-icon>
                    Attach document to message
                </button>
                <input class="width-100 display-none"
                       #multiFileUploadInput
                       id="fileUploadInpt"
                       type="file"
                       [multiple]="true"
                       [accept]="acceptedFileExtensions"
                       (change)="setFileToBeUploaded()"
                />
            </div>
            <div class="padding-left-20 padding-right-20" *ngIf="!readOnly && selectedFiles && selectedFiles.length > 0">
                <mat-list role="list">
                    <mat-list-item>
                        <div class="col-sm-1"></div>
                        <div class="col-sm-5 text-left">File Name</div>
                        <div class="col-sm-6 text-left">File Description</div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item role="listitem" *ngFor="let file of selectedFiles;let index=index">
                        <div class="col-sm-1 mat-card-connect-client-list-right">
                            <button class="mat-card-icon" mat-icon-button
                                    (click)="deleteDocument(file)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        <div class="col-sm-5 mat-card-connect-client-list-left">
                            <span class="mat-card-list-text">{{file.name}}</span>
                        </div>
                        <div class="col-sm-6 mat-card-connect-client-list-left">
                            <input class="width-100"
                                    typ="text"
                                   id="input-{{index}}"
                            />
                        </div>
                        <mat-divider></mat-divider>
                    </mat-list-item>
                </mat-list>
            </div>
            <div class="padding-left-20 padding-right-20" *ngIf="readOnly && uploadedDocuments && uploadedDocuments.length > 0">
                <mat-list role="list">
                    <mat-list-item>
                        <div class="col-sm-7 text-left">File Name</div>
                        <div class="col-sm-5 text-left">File Description</div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item role="listitem" *ngFor="let matDoc of uploadedDocuments;let index=index">
                        <div class="col-sm-7 mat-card-connect-client-list-left">
                            <span class="mat-card-list-text">{{matDoc.documentName}}</span>
                        </div>
                        <div class="col-sm-5 mat-card-connect-client-list-left">
                            <span class="mat-card-list-text">{{matDoc.description}}</span>
                        </div>
                        <mat-divider></mat-divider>
                    </mat-list-item>
                </mat-list>
            </div>
            <div class="text-right padding-10 action-buttons">
                <button *ngIf="!readOnly"  mat-raised-button color="accent"
                        class="margin-right-10"
                        (click)="onSend()">Send
                </button>
                <button *ngIf="readOnly"  mat-raised-button color="accent"
                        class="margin-right-10"
                        (click)="onCancel()">Close
                </button>
                <button *ngIf="!readOnly" mat-raised-button color="white"
                        class="margin-right-10"
                        (click)="onCancel()">Cancel
                </button>
            </div>
        </div>
        <div class="padding-left-20 padding-right-20">
            <mat-progress-bar mode="indeterminate" *ngIf="uploadInProgress"></mat-progress-bar>
        </div>
    </div>
</div>
